import DataRow from "./DataRow"

export default function DataRows({ rows, onRowClick }) {
  return rows.map((row, n) => (
    <DataRow
      key={"id" in row ? row.id : n}
      rowNumber={n}
      data={row}
      onClick={onRowClick}
    />
  ))
}
